import { PageHero } from '../components/PageHero'
import { useSeo } from '../lib/useSeo'

function Bloc({ titre, children }: { titre: string; children: React.ReactNode }) {
  return (
    <section className="border-b border-navy/10 py-6 last:border-0">
      <h2 className="font-display text-lg font-bold text-navy">{titre}</h2>
      <div className="mt-3 space-y-1.5 text-sm leading-relaxed text-ink/75">{children}</div>
    </section>
  )
}

export function Confidentialite() {
  useSeo(
    'Politique de confidentialité — Maison Gilles',
    'Politique de confidentialité et protection des données — Maison Gilles, Jambes (Namur).',
  )
  return (
    <>
      <PageHero titre="Politique de confidentialité" />
      <section className="bg-white py-12 lg:py-16">
        <div className="mx-auto max-w-3xl px-5 lg:px-8">
          <Bloc titre="1. Responsable du traitement">
            <p>
              Maison Gilles, SA, numéro BCE 0446916810, dont le siège est établi Chaussée de Marche 182,
              5100 Jambes (Belgique), joignable via info@maisongilles.be.
            </p>
          </Bloc>

          <Bloc titre="2. Finalités du traitement">
            <p>La collecte vise à gérer vos demandes transmises via le formulaire d'enlèvement et d'entretien.</p>
          </Bloc>

          <Bloc titre="3. Données collectées">
            <p>Identité : nom, prénom, civilité.</p>
            <p>Contact : adresse e-mail, numéro de téléphone, adresse postale.</p>
            <p>Demande : machines concernées et remarques que vous renseignez.</p>
            <p>Données techniques : adresse IP, utilisée uniquement pour sécuriser les formulaires et prévenir les abus.</p>
          </Bloc>

          <Bloc titre="4. Base légale">
            <p>
              Exécution d'un contrat pour le traitement des demandes d'enlèvement, et intérêt légitime
              pour la sécurité et la prévention des abus.
            </p>
          </Bloc>

          <Bloc titre="5. Destinataires">
            <p>
              Les services internes de Maison Gilles et notre hébergeur (Hetzner Online GmbH). Les e-mails
              de confirmation sont acheminés via le service de messagerie Microsoft. Vos données ne sont ni
              vendues ni cédées à des tiers à des fins commerciales.
            </p>
          </Bloc>

          <Bloc titre="6. Transfert hors UE">
            <p>
              Vos données sont hébergées au sein de l'Union européenne (serveurs Hetzner situés en
              Allemagne). Aucun transfert vers un pays hors UE n'est réalisé pour la gestion de vos demandes.
            </p>
          </Bloc>

          <Bloc titre="7. Durée de conservation">
            <p>
              Données d'identité et de contact : durée nécessaire au traitement de votre demande, puis
              conservation jusqu'à 3 ans après le dernier échange.
            </p>
          </Bloc>

          <Bloc titre="8. Cookies">
            <p>
              Le site ne dépose aucun cookie de suivi ni de publicité. Seuls des éléments techniques
              strictement nécessaires au fonctionnement (par exemple la connexion à l'espace
              d'administration) sont utilisés. La carte Google Maps ne se charge que si vous cliquez pour
              l'afficher ; elle peut alors déposer des cookies relevant de la politique de Google. Vous
              pouvez les gérer via les paramètres de votre navigateur.
            </p>
          </Bloc>

          <Bloc titre="9. Sécurité">
            <p>Des mesures techniques et organisationnelles appropriées sont mises en place.</p>
          </Bloc>

          <Bloc titre="10. Vos droits">
            <p>
              Conformément au RGPD : droits d'accès, de rectification, d'effacement, de limitation,
              d'opposition et de portabilité. Contact : info@maisongilles.be ou par courrier postal.
            </p>
          </Bloc>

          <Bloc titre="11. Réclamation">
            <p>
              Autorité de Protection des Données (APD) : Rue de la Presse 35, 1000 Bruxelles.
            </p>
          </Bloc>
        </div>
      </section>
    </>
  )
}
